<template>
  <section class="section">
    <div class="colums">
      <div class="column is-paddingless">
        <h1 class="title">Settings</h1>
      </div>
    </div>

    <div class="columns">
      <div class="column is-2">
        <nav class="panel">
          <p class="panel-heading">
            Settings
          </p>

          <a @click.prevent="changeTab('user_settings')" class="panel-block">
            User settings
          </a>
          <a @click.prevent="changeTab('user_password')" class="panel-block">
            Change Password
          </a>
          <a @click.prevent="changeTab('timezone')" class="panel-block">
            Timezone & Units
          </a>
          <a @click.prevent="changeTab('expense_categories')" class="panel-block">
            Expense Categories
          </a>
        </nav>
      </div>

      <user-settings v-if="tab === 'user_settings'" />
      <change-password v-if="tab === 'user_password'" />
      <timezone v-if="tab === 'timezone'" />
      <expense-categories v-if="tab === 'expense_categories'" />
    </div>
  </section>
</template>

<script>
import UserSettings from '../components/settings/UserSettings.vue';
import Timezone from '../components/settings/Timezone.vue';
import ExpenseCategories from '../components/settings/ExpenseCategories.vue';
import ChangePassword from '../components/settings/ChangePassword.vue';

export default {
  name: 'Settings',
  components: {
    ChangePassword,
    ExpenseCategories,
    Timezone,
    UserSettings,
  },
  data() {
    return {
      tab: 'user_settings',
    };
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
  },
};
</script>

<style scoped>

</style>
